import * as React from 'react';
import { Modal } from '../../Modal';
import { Flex } from '../FlexHelpers';
import { UserSelectorPanel } from './UserSelectorPanel';
import { PublicAmorgUser } from '../../../amorg-common';
import { getUsers } from '../../../api/userClientApi';
import { FullUserAvatar } from '../../avatar/UserAvatar';
import { FullUserAvatarCard } from '../../avatar/AvatarCard';

type UserSelectorButtonProps = {
    display?:'avatar' | 'avatar-card' | 'avatar-card-no-border'
    disabled?: boolean,
    hideEdit?: boolean,
    userFilter?: (user:PublicAmorgUser) => boolean,
    selectedUserId?:string,
    noSelectionText?:string,
    onUserChange: (user:PublicAmorgUser|null) => void,
}
export function UserSelectorButton(props:UserSelectorButtonProps):JSX.Element
{ 
    const [showModal, setShowModal] = React.useState(false);
    const [users, setUsers] = React.useState<PublicAmorgUser[] | null>(null);

    React.useEffect(() =>
    {
        if(users !== null) return;

        const getData = async () =>
        {
            let users = await getUsers(false, false);
            if (props.userFilter) {
                users = users.filter(props.userFilter);
            }
            setUsers(users);
        };
        getData();
    }, []);

    function handleSelectionChanged(user:PublicAmorgUser|null) {
        props.onUserChange(user);
        setShowModal(false);
    }

    const selectedUser = users?.find(u => u.id === props.selectedUserId);
    const canEdit = !props.hideEdit && !props.disabled && users !== null;

    return (
        <>
            {(props.display === 'avatar-card' || props.display === 'avatar-card-no-border')
                ?   <FullUserAvatarCard
                        user={selectedUser}
                        noUserText={props.noSelectionText}       
                        noBorder={props.display === 'avatar-card-no-border'}
                        onClick={canEdit? () => setShowModal(true) : undefined}
                    />
                :   <FullUserAvatar
                        user={selectedUser}
                        size="32px"
                        noUserTooltip={'Vælg bruger'}
                        onClick={canEdit? () => setShowModal(true) : undefined}
                    />
            }

            {users &&
                <UserSelectorModal
                    show={showModal}
                    selectedUserId={props.selectedUserId || ''}
                    onClose={() => setShowModal(false)}
                    onUserChange={handleSelectionChanged}
                    userFilter={props.userFilter}
                    users={users}
                />
            }
        </>
    );
}

export function UserSelectorModal(props:{
    selectedUserId: string;
    show: boolean;
    users: PublicAmorgUser[];
    onClose: () => void;
    onUserChange: (user: PublicAmorgUser | null) => void;
    userFilter?: (user: PublicAmorgUser) => boolean;
}):JSX.Element
{
    function handleSelectionChanged(userId:string) {
        props.onUserChange(userId === '' ? null : props.users.find(u => u.id === userId) || null);
        props.onClose();
    }

    return (
        <Modal
            showModal={props.show}
            title={'Vælg ejer'}
            onCancel={props.onClose}
            content={
                <Flex flexDirection='column' gap={16}>
                    <UserSelectorPanel
                        users={props.users}
                        showNone={true}
                        onSelectionChanged={handleSelectionChanged}
                    />
                </Flex>
            }
        />
    );
}